// extracted by mini-css-extract-plugin
export default {"root":"_3CD5ayP9","show-on-hover":"vC0s-89t","content":"j4okM2U1"};